define('v3/Common/Bindings/SelectionBar.Binding',['jquery', 'knockout'], function ($, ko) {
	ko.bindingHandlers.selectionBar = {
		update: function (element, valueAccessor, allBindings, params) {
			var visible = params.isVisible();
			var body = $('body');

			setTimeout(function () {
				if (visible) {
					var height = $(element).prop('scrollHeight');
					body.css('padding-bottom', height);
				} else {
					body.css('padding-bottom', 0);
				}
			}, 0);
		}
	};
});
